import { render, staticRenderFns } from "./Adaptives.vue?vue&type=template&id=bf7f232a&"
import script from "./Adaptives.vue?vue&type=script&lang=js&"
export * from "./Adaptives.vue?vue&type=script&lang=js&"
import style0 from "./Adaptives.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf7f232a')) {
      api.createRecord('bf7f232a', component.options)
    } else {
      api.reload('bf7f232a', component.options)
    }
    module.hot.accept("./Adaptives.vue?vue&type=template&id=bf7f232a&", function () {
      api.rerender('bf7f232a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/adaptives/Adaptives.vue"
export default component.exports